export const STEPS = [
  { n: 1, key: "patient", label: "Patient Details" },
  { n: 2, key: "exam", label: "Examination" },
  { n: 3, key: "history", label: "Clinical History" },
  { n: 4, key: "upload", label: "Upload Documents" },
  { n: 5, key: "review", label: "Final Review" },
];

// Doctor's orientation: Mandible on top, Maxilla at the bottom.
export const MAND = ["48", "47", "46", "45", "44", "43", "42", "41", "31", "32", "33", "34", "35", "36", "37", "38"];
export const MAX = ["18", "17", "16", "15", "14", "13", "12", "11", "21", "22", "23", "24", "25", "26", "27", "28"];
export const MAND_PRIMARY = ["85", "84", "83", "82", "81", "71", "72", "73", "74", "75"];
export const MAX_PRIMARY = ["55", "54", "53", "52", "51", "61", "62", "63", "64", "65"];
export const archOf = (fdi) => (["1", "2", "5", "6"].includes(String(fdi)[0]) ? "maxilla" : "mandible");

export const SMILE_LINES = ["High", "Medium", "Low"];
export const TISSUE = ["Thick", "Thin"];
export const IMPLANT_CONDITIONS = ["Caries", "Fractured", "Root stump", "Mobile", "Missing", "Existing restoration", "Existing crown/bridge", "Existing implant", "Other"];
export const GENERAL_CONDITIONS = ["Caries", "Fractured tooth", "Suspected crack", "Attrition", "Abrasion", "Erosion", "Non-carious cervical lesion", "Defective restoration", "Recurrent caries", "Root stump", "Mobile tooth", "Missing tooth", "Discoloration", "Existing restoration", "Other"];
export const RIDGE = ["None", "Horizontal", "Vertical", "Combined", "Not assessed"];
export const BONE_QUALITY = ["D1", "D2", "D3", "D4", "Not assessable"];
export const LIMITATIONS = ["Sinus proximity", "Nerve canal proximity", "Adjacent root", "Other", "None documented"];
export const EDENTULISM = ["Single tooth", "Partial", "Complete"];

export const TMJ_COMPLAINTS = ["TMJ pain", "Clicking or popping", "Restricted mouth opening", "Jaw locking", "Deviation on opening", "Difficulty chewing", "Headache", "Facial pain"];
export const TMJ_TENDER = ["None", "TMJ", "Temporalis", "Masseter", "Lateral pterygoid"];
export const GENERAL_COMPLAINTS = ["Toothache", "Sensitivity", "Caries or cavity", "Broken tooth", "Swollen gums", "Bleeding gums", "Loose tooth", "Missing tooth", "Food lodgement", "Bad breath", "Tooth discoloration", "Routine check-up"];
export const IMPLANT_COMPLAINTS = ["Missing tooth", "Difficulty chewing", "Loose denture", "Aesthetic concern", "Failed bridge"];
export const COMPLAINTS = { implant: IMPLANT_COMPLAINTS, general: GENERAL_COMPLAINTS, tmj: TMJ_COMPLAINTS };

export const INVESTIGATIONS = {
  implant: ["IOPA", "OPG", "CBCT", "Other"],
  tmj: ["MRI TMJ", "OPG", "CBCT", "CT scan", "X-ray", "Blood investigations", "Previous consultation or treatment report", "Other"],
  general: ["IOPA", "Bitewing", "OPG", "CBCT", "Pulp vitality test", "Periodontal chart", "Other report"],
};
export const TMJ_INVESTIGATIONS = INVESTIGATIONS.tmj;
export const SCREENING = {
  tmj: ["Fever or swelling around the joint", "Recent significant trauma", "Sudden inability to open or close the jaw", "Rapidly worsening pain or swelling", "New neurological symptoms"],
  general: ["Facial swelling spreading rapidly", "Fever with dental swelling", "Difficulty swallowing or breathing", "Uncontrolled oral bleeding", "Significant facial trauma"],
};
export const MED_CONDITIONS = {
  implant: ["Diabetes", "Hypertension", "Cardiac disease", "Bleeding disorder", "Osteoporosis", "Head & neck radiotherapy", "Immunosuppression", "Renal impairment", "Hepatic impairment"],
  tmj: ["Inflammatory joint disease", "Neurological condition", "Bleeding disorder", "Renal impairment", "Hepatic impairment"],
  general: ["Diabetes", "Hypertension", "Cardiac disease", "Bleeding disorder / anticoagulants", "Renal impairment", "Hepatic impairment"],
};
export const COND_STATUS = ["Not applicable", "Controlled", "Uncontrolled", "Unknown"];
export const HABITS = ["Clenching", "Bruxism", "Gum chewing", "Nail biting", "None", "Unknown"];
export const MODALITIES = ["CBCT", "OPG", "IOPA", "Clinical photo", "Other"];
export const MEASURE_FIELDS = [
  { key: "bone_width", label: "Bone width", cbct: true },
  { key: "bone_height", label: "Bone height", cbct: true },
  { key: "nerve", label: "To nerve canal", cbct: true },
  { key: "sinus", label: "To sinus floor", cbct: false },
];
export const MEASURE_SOURCES = ["CBCT", "OPG", "IOPA", "Clinical", "Other"];

export const NOTE_SHORTCUTS = [
  { group: "Medical", items: ["Hypertension", "Diabetes", "Cardiac disease", "On anticoagulants", "No significant medical history"] },
  { group: "Habits", items: ["Smoker", "Tobacco chewing", "Bruxism", "Alcohol use"] },
  { group: "Dental", items: ["Previous extractions", "Previous RCT", "Denture wearer", "Orthodontic history"] },
];

export const ACCEPT_EXT = ["pdf", "jpg", "jpeg", "png", "webp", "heic", "dcm"];
export const MAX_BYTES = 25 * 1024 * 1024;
export const NA = "Not assessed";

const todayIso = () => new Date().toISOString().slice(0, 10);

export function blankExam() {
  return {
    implant: { complaints: [], complaint_text: "", dentition: "edentulous", arch: "both", smile_line: "", sites: {}, edentulism: { maxilla: "", mandible: "" } },
    general: { complaints: [], complaint_text: "", dentition: "Permanent", duration: "", pain: "", hygiene: "", chart_mode: "dentulous", teeth: {}, mobility: "", perio_status: "", pulp_status: "" },
    tmj: { complaints: [], complaint_text: "", duration: "", side: "", opening: "", max_opening: "", dev_open_l: "", dev_open_r: "", dev_close_l: "", dev_close_r: "", sounds_r: "", sounds_l: "", locking: "", tender_r: [], tender_l: [], trauma: "", pain_score: "" },
  };
}

const blankHistory = () => ({ conditions: {}, condition_other: "", meds: [], antiresorptive: false, anticoagulant: false, allergies: { none: false, list: [] },
  smoking: "", smoking_per_day: "", pregnancy: "", expectations: { desired: "", limitations: "" }, habits: [], notes: "" });
const blankUpload = () => ({ investigations: [], other: "", notes: "", screening: [], screening_none: false, ack: false });

export function blankWizard(c) {
  const exam = blankExam();
  exam.implant.sites = fromVoiceSites(c, "implant");
  exam.general.teeth = fromVoiceSites(c, "general");
  exam[c?.condition || "implant"] && (exam[c?.condition || "implant"].complaint_text = c?.chief_complaint || "");
  return {
    step: 1, reached: 1,
    patient: { mode: c?.patient_id ? "existing" : "new", patient_id: c?.patient_id || null, name: c?.patient_id ? c.patient_name : (c?.extracted_patient?.name || ""),
      age: c?.extracted_patient?.age || "", gender: c?.extracted_patient?.gender || "", phone: c?.extracted_patient?.phone || "", email: c?.extracted_patient?.email || "", date: todayIso() },
    exam,
    history: { ...blankHistory(), notes: voiceNotes(c), expectations: { desired: c?.patient_expectations || "", limitations: "" } },
    upload: blankUpload(), measurements: {},
    approved_at: null, stale: false,
  };
}

export function normalizeWizard(w, c) {
  if (!w) return blankWizard(c);
  const ex = blankExam();
  const exam = {};
  Object.keys(ex).forEach((k) => { exam[k] = { ...ex[k], ...((w.exam || {})[k] || {}) }; });
  if (Array.isArray(w.exam?.tmj?.findings) || w.exam?.tmj?.findings) delete exam.tmj.findings;
  return { ...w, exam, history: { ...blankHistory(), ...(w.history || {}) }, upload: { ...blankUpload(), ...(w.upload || {}) }, measurements: w.measurements || {} };
}

function fromVoiceSites(c, kind) {
  const out = {};
  (c?.tooth_findings || []).forEach((t) => {
    const fdi = String(t.fdi);
    const extraction = /root stump|mobile|grossly|fractur/i.test(t.status || "");
    out[fdi] = kind === "implant"
      ? { plan: extraction ? "extraction" : "implant" }
      : { condition: GENERAL_CONDITIONS.includes(t.status) ? t.status : "Other", other: GENERAL_CONDITIONS.includes(t.status) ? "" : (t.status || ""), plan: extraction ? "extraction" : "natural" };
  });
  (c?.sites || []).forEach((s) => {
    const fdi = String(s.site || "");
    if (!/^\d{2}$/.test(fdi)) return;
    out[fdi] = { ...(out[fdi] || (kind === "implant" ? { plan: "implant" } : { condition: "Missing tooth", other: "", plan: "natural" })),
      md: s.md ?? "", bl: s.bl ?? "", inter_arch: s.vertical ?? "", tissue: s.tissue ? (String(s.tissue).toLowerCase().includes("thin") ? "Thin" : "Thick") : "" };
  });
  return out;
}

function voiceNotes(c) {
  return [...(c?.medical_history || []), ...(c?.dental_history || [])].map((x) => `• ${typeof x === "string" ? x : JSON.stringify(x)}`).join("\n");
}

const num = (v) => (v === "" || v == null || isNaN(Number(v)) ? null : Number(v));
export const complaintOf = (w, slug) => {
  const ex = w.exam?.[slug] || {};
  const h = w.history || {};
  return [...(ex.complaints || []), ex.complaint_text, ...(h.complaints || []), h.complaint_text].filter(Boolean).join("; ");
};

export function toConsultationFields(w, slug) {
  const p = w.patient || {};
  const fields = { patient_id: p.patient_id || null, patient_name: p.name || "", chief_complaint: complaintOf(w, slug) };
  const ex = w.exam?.[slug] || {};
  const map = ex.sites || ex.teeth || {};
  if (slug === "implant" || slug === "general") {
    fields.tooth_findings = Object.entries(map).map(([fdi, t]) => ({ fdi, status: t.condition === "Other" ? (t.other || "Other") : (t.condition || (t.plan === "extraction" ? "Extraction planned" : slug === "implant" ? "Missing" : "Examined")), confidence: 100 }));
    fields.sites = Object.entries(map).map(([fdi, t]) => ({ site: fdi, status: t.plan === "extraction" ? "Extraction" : t.plan === "implant" ? "Implant" : "Natural tooth", md: num(t.md), bl: num(t.bl), vertical: num(t.inter_arch), tissue: t.tissue || null }));
    if (slug === "implant") fields.arch_status = ex.arch === "both" ? "Both arches" : ex.arch;
  } else {
    fields.tooth_findings = [];
    fields.sites = [];
  }
  return fields;
}

export const validMm = (v) => v === "" || v == null || (/^\d+(\.\d)?$/.test(String(v)) && Number(v) >= 0 && Number(v) <= 80);

export function missingChecks(w, slug, docs) {
  const red = [];
  const amber = [];
  const pending = docs.reduce((n, d) => n + (d.review_items || []).filter((x) => x.status === "pending").length, 0);
  if (pending) amber.push({ step: 5, text: `${pending} AI imaging finding(s) awaiting your review (required before generating the report)` });
  if (!w.patient?.patient_id && !w.patient?.name?.trim()) red.push({ step: 1, text: "No patient selected or added" });
  if (!slug) red.push({ step: 2, text: "No condition selected" });
  const ex = w.exam?.[slug] || {};
  const up = w.upload || {};
  if (!(ex.complaints?.length || ex.complaint_text?.trim())) amber.push({ step: 2, text: "Chief complaint not recorded" });
  if (slug === "implant") {
    if (!Object.keys(ex.sites || {}).length) amber.push({ step: 2, text: "No implant sites marked on the chart" });
    if (!ex.smile_line) amber.push({ step: 2, text: "Smile line not recorded" });
  }
  if (slug === "general") {
    if (!Object.keys(ex.teeth || {}).length) amber.push({ step: 2, text: "No teeth selected on the chart" });
    const noCond = Object.entries(ex.teeth || {}).filter(([, t]) => !t.condition).map(([f]) => f);
    if (noCond.length) red.push({ step: 2, text: `Condition required for tooth ${noCond.join(", ")}` });
    Object.entries(ex.teeth || {}).forEach(([f, t]) => { if (t.condition === "Other" && !t.other?.trim()) red.push({ step: 2, text: `Describe "Other" condition for tooth ${f}` }); });
  }
  if (slug === "implant") Object.entries(ex.sites || {}).forEach(([f, t]) => { if (t.condition === "Other" && !t.other?.trim()) red.push({ step: 2, text: `Describe "Other" condition for tooth ${f}` }); });
  if (slug === "tmj") {
    if (ex.opening === "Restricted" && !ex.max_opening) amber.push({ step: 2, text: "Mouth opening is restricted but maximum opening (mm) is not recorded" });
    ["duration", "side", "opening", "locking", "trauma"].forEach((k) => { if (!ex[k]) amber.push({ step: 2, text: `TMJ ${k.replace("_", " ")} not recorded (shown as Not assessed)` }); });
    if (ex.pain_score !== "" && ex.pain_score != null && !(Number(ex.pain_score) >= 0 && Number(ex.pain_score) <= 10)) red.push({ step: 2, text: "Pain score must be 0–10" });
  }
  const mmBad = Object.values(ex.sites || ex.teeth || {}).some((s) => ![s.md, s.bl, s.inter_arch, s.kt_mm, s.recession_mm].every(validMm)) || !validMm(ex.max_opening);
  if (mmBad) red.push({ step: 2, text: "A mm value is outside 0–80 or has more than one decimal" });
  const h = w.history || {};
  if (!h.allergies?.none && !(h.allergies?.list || []).length) amber.push({ step: 3, text: "Allergies not recorded" });
  if (!(up.investigations || []).length) amber.push({ step: 4, text: "Investigations reviewed not recorded" });
  if (SCREENING[slug]) {
    if ((up.screening || []).length && !up.ack) red.push({ step: 4, text: "Safety warning sign ticked — acknowledge the urgent-referral guidance" });
    if (!(up.screening || []).length && !up.screening_none) amber.push({ step: 4, text: "Safety screening not answered (tick signs or 'None of these')" });
  }
  if (!docs.length) amber.push({ step: 4, text: "No documents or radiographs uploaded" });
  return { red, amber };
}
